import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { gsap } from "../../gsap/gsap.min.js";
import { ScrollSmoother } from "../../gsap/ScrollSmoother.min.js";

gsap.registerPlugin(ScrollSmoother);

const PageTransition = ({ running }) => {
	const [active, setActive] = useState(false);
	
	let location = useLocation()

	useEffect(() => {
		if (active) {
			gsap.fromTo("#transition-element", {
				background: "#ffffff75",
				backdropFilter: "blur(40px)"
			}, {
				background: "none",
				backdropFilter: "blur(0px)",
				duration: 1,
				ease: "power1.inOut", 
			});
		}
	}, [location]);

	useEffect(() => {
		setActive(running);
	}, [running]);
	
	return (
		<div id="transition-element" className={active ? "active" : ""}></div>
	);
};

export default PageTransition;
